import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { INTERNSHIPS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/internships/")({
  component: () => <DeptContentList cfg={INTERNSHIPS} />,
});
